import {useEffect, useState} from "react";
import appOptions from "./options";

export default function useIsMobile() {
    let [w, setW] = useState();

    useEffect(() => {
        let onWndResize = () => {
            setW(window.innerWidth);
        };

        window.addEventListener('resize', onWndResize);

        // must set on loading first time
        onWndResize();

        return () => window.removeEventListener('resize', onWndResize);
    }, []);

    return w <= appOptions.breakPoint;
}